import SectionFour from "../homecomponent/SectionFour";
const Profile = () => {
    return (
        <div className=" ">
            <SectionFour />
        </div>
    );
};
export default Profile;
